import React from "react";
import { Wrapper } from "./styles";
import GoogleMapsReact from "google-map-react";
import Marker from "../../../../components/Marker";

interface ICoordinates {
  latitude: number;
  longitude: number;
}

interface IProps {
  latitude?: number;
  longitude?: number;
  address?: string;
  toggle: boolean;
}

const DEFAULT_CENTER = { lat: -3.7301571, lng: -38.5144071 };

const getCenter = (latitude?: number, longitude?: number) => {
  if (latitude && longitude) {
    return {
      lat: latitude,
      lng: longitude,
    };
  }
  return DEFAULT_CENTER;
};

function MapSection({ latitude, longitude, address, toggle }: IProps) {
  const [coordinates, setCoordinates] = React.useState<ICoordinates | null>(
    latitude && longitude ? { latitude, longitude } : null
  );

  function getLatLong(apiKey: string | undefined, address: string) {
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      address
    )}&key=${apiKey}`;

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          const location = data.results[0].geometry.location;
          const latitude = location.lat;
          const longitude = location.lng;
          setCoordinates({ latitude, longitude });
        } else {
          console.error(`Erro: ${data.status}`);
        }
      })
      .catch((error) => {
        console.error("Erro ao obter as coordenadas:", error);
      });
  }

  React.useEffect(() => {
    if (latitude && longitude) {
      setCoordinates({ latitude, longitude });
      return;
    }

    async function getCoordinates() {
      if (address) {
        const formattedAddress = `${address}, Brasil`;
        getLatLong(
          process.env.REACT_APP_GOOGLE_MAPS_KEY ?? "AIzaSyDSD2QM4JfZsREcRj_8StrW3E587RayIMc",
          formattedAddress
        );
      }
    }

    getCoordinates();
  }, [latitude, longitude, address]);

  const handleApiLoaded = ({ map, maps }: any) => {
    map.setOptions({
      gestureHandling: "greedy",
    });
  };

  const center = coordinates
    ? { lat: coordinates.latitude, lng: coordinates.longitude }
    : getCenter(latitude, longitude);

  return (
    <Wrapper className={toggle ? "show" : undefined}>
      <GoogleMapsReact
        bootstrapURLKeys={{
          key: process.env.REACT_APP_GOOGLE_MAPS_KEY ?? "AIzaSyDSD2QM4JfZsREcRj_8StrW3E587RayIMc",
        }}
        defaultCenter={DEFAULT_CENTER}
        center={center}
        defaultZoom={14}
        options={{
          gestureHandling: "greedy",
          streetViewControl: false,
          fullscreenControl: false,
          zoomControlOptions: { position: 7 },
        }}
        yesIWantToUseGoogleMapApiInternals={true}
        onGoogleApiLoaded={handleApiLoaded}
      >
        {coordinates && (
          <Marker
            lat={coordinates.latitude}
            lng={coordinates.longitude}
            color="#6EA6FF"
          />
        )}
      </GoogleMapsReact>
    </Wrapper>
  );
}

export default MapSection;